<template>
  <li>
    <div class="rd-deep-1 expanded">
      <b-container fluid>
        <b-row>
          <b-col cols="4">
            <div class="d-flex align-items-end h-100">
              <div class="font-weight-medium">{{ lens.lenses.supplier.name }}</div>
            </div>
          </b-col>
          <b-col cols="7">
            <div class="d-flex align-items-center h-100">
              <div class="font-weight-medium">{{ lens.lenses.name }}</div>
              <div class="upgrade-badge-container" style="position: relative; display: inline-block;margin-left:5px;"  v-if="lens.is_upgrade && lens.upgrade_reason">
                <b-badge 
                  variant="warning" 
                  @mouseenter="showTooltip = true"
                  @mouseleave="showTooltip = false"
                  style="cursor: help;"
                >
                  UPGRADED
                </b-badge>
                <div 
                  v-if="showTooltip" 
                  class="custom-tooltip"
                  style="
                    position: absolute;
                    bottom: 100%;
                    left: 50%;
                    transform: translateX(-50%);
                    background: #333;
                    color: white;
                    padding: 8px 12px;
                    border-radius: 4px;
                    font-size: 12px;
                    z-index: 1000;
                    margin-bottom: 5px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
                    width: 300px;
                    white-space: normal;
                    word-wrap: break-word;
                    text-align: center;
                  "
                >
                  {{ lensUpgradeReason }}
                  <div style="
                    position: absolute;
                    top: 100%;
                    left: 50%;
                    transform: translateX(-50%);
                    border: 5px solid transparent;
                    border-top-color: #333;
                  "></div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <div class="rdd1-part rdd1-part__icon rdd1-part__radio" v-if="selectable">
        <b-form-radio 
          v-model="$store.state.jobsModule.selectedLens" 
          :value="radioValue" 
          :name="'lens-' + lens.id"
          @change="onChange"
        > 
        </b-form-radio>
      </div>
    </div>
    <div class="rd-deep-2">
      <b-container fluid>
        <b-row>
          <b-col cols="4">
            <h6 class="text-uppercase">Thickness</h6>
            <div>{{ lens.lenses.display_thickness }}</div>
          </b-col>
          <b-col cols="4">
            <h6 class="text-uppercase">Lens Coating(s)</h6>
            <div>{{ lens.lenses.coating }}</div>
            <div v-if="lens.coating && (lens.coating.display_name || lens.coating.name)">
              <hr />
              {{ lens.coating.display_name || lens.coating.name }}
            </div>
          </b-col>

          <b-col cols="4" v-if="lens.lenses.lens_color">
            <h6 class="text-uppercase">Color</h6>
            <div>{{ lens.lenses.lens_color.name }}</div>
          </b-col>

          <b-col cols="4" v-if="lens.tint">
            <h6 class="text-uppercase">Tint</h6>
            <div>{{ lens.tint.display_name }}</div>
          </b-col>
        </b-row>
        <b-row class="mt-2" v-if="lens.invalid_error_msg">
          <b-col cols="12">
            <span
              class="text-danger text-decoration-underline font-weight-bold"
              style="text-decoration: underline"
            >
              Warning
            </span>
            <p class="small text-danger">{{ lens.invalid_error_msg }}</p>
          </b-col>
        </b-row>

        <b-row class="mt-2" v-if="checkWarningMessage">
          <b-col cols="12">
            <p class="warning mr-2 mt-3">{{ lens.lenses.warning_message }}</p>
          </b-col>
        </b-row>
        
        <b-row class="mt-3" v-if="hasStyleMods">
          <b-col cols="12" class="d-flex align-items-center">
            <span class="lens-style-label">LENS STYLE</span>
            <div class="lens-mod-group">
              <label
                v-for="mod in styleMods"
                :key="mod.id"
                class="lens-mod-pill"
                :class="{
                  'lens-mod-pill--active': isLensSelected && selectedModId === mod.id,
                  'lens-mod-pill--disabled': !isLensSelected
                }"
                :title="mod.code"
                @click="isLensSelected && selectMod(mod)"
              >
                {{ mod.name }}
              </label>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-3" v-if="hasCorridorMods">
          <b-col cols="12" class="d-flex align-items-center">
            <span class="lens-style-label">CORRIDOR</span>
            <div class="lens-mod-group">
              <label
                v-for="mod in corridorMods"
                :key="mod.id"
                class="lens-mod-pill"
                :class="{
                  'lens-mod-pill--active': isLensSelected && selectedCorridorModId === mod.id,
                  'lens-mod-pill--disabled': !isLensSelected
                }"
                :title="mod.code"
                @click="isLensSelected && selectCorridorMod(mod)"
              >
                {{ mod.name }}
              </label>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-2" v-if="lens.is_upgrade">
          <b-col cols="12">
            <div class="d-flex align-items-center justify-content-end">
              <span class="mr-3" style="white-space: nowrap;">Reason for the upgrade</span>
              <b-form-input
                v-model="tempUpgradeReason"
                placeholder="Enter reason"
                :readonly="!isLensSelected"
                style="max-width: 300px;"
                @input="$emit('upgrade-reason-input', tempUpgradeReason)"
              ></b-form-input>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </li>
</template>

<script>
export default {
  name: 'LensListItem',
  props: {
    lens: Object,
    selectable: Boolean,
    collapsible: Boolean,
  },
  data() {
    return {
      visible: false,
      showTooltip: false,
      tempUpgradeReason: '',
      selectedModId: null,
      selectedCorridorModId: null,
    };
  },
  computed: {
    checkWarningMessage() {
      return this._.get(this.lens, 'lenses.warning_message');
    },
    lensUpgradeReason() {
      return this.lens.upgrade_reason || '';
    },
    isLensSelected() {
      const selectedLens = this.$store.state.jobsModule.selectedLens;
      if (!selectedLens || !this.lens) return false;
      if (selectedLens.id && this.lens.id) {
        return selectedLens.id === this.lens.id;
      }
      return selectedLens.lens_id === this.lens.lens_id;
    },
    styleMods() {
      const mods = this._.get(this.lens, 'lenses.lens_mods', []);
      return mods.filter(m => m.type === 'lens_style');
    },
    corridorMods() {
      const mods = this._.get(this.lens, 'lenses.lens_mods', []);
      const order = { long: 0, medium: 1, short: 2 };
      return mods
        .filter(m => m.type === 'lens_corridor')
        .sort((a, b) => {
          const aOrder = order[a.name.toLowerCase()] ?? 99;
          const bOrder = order[b.name.toLowerCase()] ?? 99;
          return aOrder - bOrder;
        });
    },
    hasStyleMods() {
      return this.styleMods.length > 0;
    },
    hasCorridorMods() {
      return this.corridorMods.length > 0;
    },
    hasLensMods() {
      return this.hasStyleMods || this.hasCorridorMods;
    },
    radioValue() {
      return this.lens;
    },
  },
  
  mounted() {
    // Check if this lens is already selected and has an upgrade reason
    if (this.isLensSelected && this.lens.is_upgrade && this.lens.upgrade_reason) {
      this.tempUpgradeReason = this.lens.upgrade_reason;
    }
    if (this.isLensSelected && this.hasStyleMods) {
      this.initDefaultMod();
    }
    if (this.isLensSelected && this.hasCorridorMods) {
      this.initDefaultCorridorMod();
    }
  },

  watch: {
    lens: {
      immediate: true,
      handler(newLens) {
        if (newLens && this.isLensSelected && newLens.is_upgrade && newLens.upgrade_reason) {
          this.tempUpgradeReason = newLens.upgrade_reason;
        }
      }
    },
    isLensSelected(newVal) {
      if (newVal && this.lens.is_upgrade) {
        this.tempUpgradeReason = this.lens.upgrade_reason || '';
      }
      if (newVal && this.hasStyleMods) {
        this.initDefaultMod();
      }
      if (newVal && this.hasCorridorMods) {
        this.initDefaultCorridorMod();
      }
      if (!newVal) {
        this.selectedModId = null;
        this.selectedCorridorModId = null;
      }
    },
    'lens.upgrade_reason'(newVal) {
      if (this.isLensSelected && this.lens.is_upgrade) {
        this.tempUpgradeReason = newVal || '';
      }
    }
  },
  
  methods: {
    onChange() {
      this.tempUpgradeReason = '';
    },
    selectMod(mod) {
      this.selectedModId = mod.id;
      this.updateStoreMod(mod);
    },
    selectCorridorMod(mod) {
      this.selectedCorridorModId = mod.id;
      this.$store.commit('jobsModule/SET_SELECTED_LENS_MOD_CORRIDOR', mod);
    },
    initDefaultMod() {
      const mods = this.styleMods;
      const currentLens = this.$store.state.jobsModule.selectedLens;
      if (currentLens && currentLens.selected_lens_mod) {
        const existing = mods.find(m => m.id === currentLens.selected_lens_mod.id);
        if (existing) {
          this.selectedModId = existing.id;
          this.updateStoreMod(existing);
          return;
        }
      }
      const defaultMod = mods.find(m => m.is_default) || mods[0];
      this.selectedModId = defaultMod.id;
      this.updateStoreMod(defaultMod);
    },
    initDefaultCorridorMod() {
      const mods = this.corridorMods;
      const currentLens = this.$store.state.jobsModule.selectedLens;
      if (currentLens && currentLens.selected_lens_mod_corridor) {
        const existing = mods.find(m => m.id === currentLens.selected_lens_mod_corridor.id);
        if (existing) {
          this.selectedCorridorModId = existing.id;
          this.$store.commit('jobsModule/SET_SELECTED_LENS_MOD_CORRIDOR', existing);
          return;
        }
      }
      const defaultMod = mods.find(m => m.is_default) || mods[0];
      this.selectedCorridorModId = defaultMod.id;
      this.$store.commit('jobsModule/SET_SELECTED_LENS_MOD_CORRIDOR', defaultMod);
    },
    updateStoreMod(mod) {
      this.$store.commit('jobsModule/SET_SELECTED_LENS_MOD', mod);
    },
  },
};
</script>

<style scoped>
.lens-style-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-right: 12px;
  white-space: nowrap;
}

.lens-mod-group {
  display: flex;
  gap: 6px;
}

.lens-mod-pill {
  display: inline-block;
  padding: 4px 14px;
  font-size: 12px;
  font-weight: 500;
  color: #495057;
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.15s ease;
  margin: 0;
  line-height: 1.4;
  user-select: none;
}

.lens-mod-pill:hover {
  border-color: #80bdff;
  color: #0056b3;
  background: #f0f6ff;
}

.lens-mod-pill--disabled {
  opacity: 0.45;
  cursor: default;
}

.lens-mod-pill--disabled:hover {
  border-color: #ced4da;
  color: #495057;
  background: #fff;
}

.lens-mod-pill--active {
  background: #007bff;
  border-color: #007bff;
  color: #fff;
}

.lens-mod-pill--active:hover {
  background: #0069d9;
  border-color: #0062cc;
  color: #fff;
}
</style>
